export const FEATURE_VIEWER_CLOSE = 'FEATUREVIEWER:FEATURE_VIEWER_CLOSE';
export const FEATURE_VIEWER_SET_LOADING = 'FEATUREVIEWER:SET_LOADING';
export const FEATURE_VIEWER_LOADED = 'FEATUREVIEWER:RECORD_LIST_LOADED';
export const FEATURE_VIEWER_LOAD_ERROR = 'FEATUREVIEWER:RECORD_LIST_LOAD_ERROR';